import React, {useState} from 'react';
import {Text, View, TouchableOpacity, ActivityIndicator} from 'react-native';
import I18n from 'i18n-js';

import {styles} from './styles';
import InfoTextWithTooltip from './infoTextWithTooltip';
import {useDispatch} from 'react-redux';
import {printToteLabels} from '../../actions/scanToCartActions';

const RenderCartHeader = ({name, id, screenWidth, cartId, cart, onDuplicateCart}) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const label = I18n.t('scanToCart.dimensions')

  const handlePrintToteLabel = () => {
    setLoading(true);
    dispatch(printToteLabels(cartId, callBack));
  };

  const callBack = () => {
    setLoading(false);
  };

  const handleDuplicateCart = ()=>{
    onDuplicateCart(cart);
  }

  return (
    <>
      <View style={styles.cartHeader}>
        <View style={{width: 150, display: screenWidth < 900 && 'none'}} />
          <View style={{flexDirection: 'row', alignItems: 'center', gap: 8}}>
            <Text
              style={[styles.cartTitle, {fontSize: screenWidth < 768 ? 18 : 20}]}>
              {name}
            </Text>
              <TouchableOpacity
                testID="duplicateCart"
                onPress={handleDuplicateCart}>
                <i
                  className="icon-docs"
                  style={{
                    color: '#aad9fc',
                    fontSize: 16,
                  }}
                  title={I18n.t('scanToCart.duplicateCart')}>
                </i>
              </TouchableOpacity>
          </View>
        {loading ? (
          <>
            <ActivityIndicator />
          </>
        ) : (
          <TouchableOpacity
            testID='printToteLabel'
            style={styles.printButton}
            onPress={handlePrintToteLabel}>
            <i
              className="icon-print"
              style={{fontSize: 24, color: '#ffff'}}></i>
            <Text
              style={[
                styles.printButtonText,
                {fontSize: screenWidth < 768 ? 12 : 14}
              ]}>
              {I18n.t('scanToCart.printToteLabel')}
            </Text>
          </TouchableOpacity>
        )}
      </View>

      <View style={styles.headerRow}>
        <View style={styles.rowIdColumn}>
          <Text style={styles.headerText}>
            {I18n.t('scanToCart.rowIdLabel')}
          </Text>
        </View>
        <View style={styles.orderInfoColumn}>
          <InfoTextWithTooltip cartId={id} screenWidth={screenWidth} />
        </View>
        <View style={styles.totesRowColumn}>
          <Text style={styles.headerText}>
            {I18n.t('scanToCart.totesInRowLabel')}
          </Text>
        </View>
        {screenWidth > 900  && <View style={styles.dimensionsColumn}>
          <Text style={styles.headerText}>
            {label}<Text style={{fontSize: 12}}> LWH</Text> (in)
          </Text>
        </View>}
      </View>
    </>
  );
};
export default RenderCartHeader;
